var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeTotalNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 64,
    height: 64,
    fill: "#fff",
    stroke: "#1d3943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,510.18C116.1,510.18,2.28,396.16,2.28,256S116.1,1.82,256,1.82,509.72,115.84,509.72,256,395.9,510.18,256,510.18Z",
    strokeMiterlimit: 10,
    strokeWidth: 4.56
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 256,
    rx: 217.72,
    ry: 218.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.27,222.3a13.55,13.55,0,1,0,13.52,13.55A13.56,13.56,0,0,0,353.27,222.3Zm-194.51,0a13.55,13.55,0,1,0,13.53,13.55A13.57,13.57,0,0,0,158.76,222.3ZM313,197.64a20.16,20.16,0,1,0,20.16,20.17A20.15,20.15,0,0,0,313,197.64Zm62.48,122.66H352.55V278A39.5,39.5,0,0,0,347,258.11a22,22,0,0,1,6.28-1,22.29,22.29,0,0,1,22.22,22.28ZM199,197.64a20.16,20.16,0,1,0,20.12,20.17A20.18,20.18,0,0,0,199,197.64ZM158.76,257.1a21.76,21.76,0,0,1,6.24,1A39.12,39.12,0,0,0,159.45,278v42.31H136.51V279.38A22.29,22.29,0,0,1,158.76,257.1ZM256,157.33a29.83,29.83,0,1,0,29.78,29.82A29.84,29.84,0,0,0,256,157.33ZM345.17,336H310V271.68a53.31,53.31,0,0,0-6.1-24.46,31.75,31.75,0,0,1,9.06-1.46A32.24,32.24,0,0,1,345.17,278ZM201.92,271.68V336h-35.1V278A32.24,32.24,0,0,1,199,245.76a31.43,31.43,0,0,1,9,1.46A53.51,53.51,0,0,0,201.92,271.68Zm7.38,83h93.35v-83a46.67,46.67,0,1,0-93.35,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeTotalNumber);
export default __webpack_public_path__ + "static/media/employee_total_number.619c8a7ec48a2b6f6e05f24dc8aea63a.svg";
export { ForwardRef as ReactComponent };